import { render, staticRenderFns } from "./postavshikDialog.vue?vue&type=template&id=16cf23e7&scoped=true&"
import script from "./postavshikDialog.vue?vue&type=script&lang=js&"
export * from "./postavshikDialog.vue?vue&type=script&lang=js&"
import style0 from "./postavshikDialog.vue?vue&type=style&index=0&id=16cf23e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf23e7",
  null
  
)

export default component.exports